var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CookieCompact } from './CookieCompact';
import { CookieDetail } from './CookieDetail';
export var CookieContent = function (_a) {
  var cookies = _a.cookies,
    contentCompact = _a.contentCompact,
    contentDetail = _a.contentDetail,
    onSubmitClick = _a.onSubmitClick,
    toggleView = _a.toggleView,
    view = _a.view;
  var _b = useState(cookies),
    cookiesConsent = _b[0],
    setCookiesConsent = _b[1];
  var handleConsentClick = function (grantAll) {
    onSubmitClick(cookiesConsent, grantAll);
  };
  var handleSwitchOption = function (cookieName, cookieValue) {
    var _a;
    var updatedCookies = __assign(__assign({}, cookiesConsent), (_a = {}, _a[cookieName] = cookieValue ? 'granted' : 'denied', _a));
    setCookiesConsent(updatedCookies);
  };
  return _jsxs(_Fragment, {
    children: [view === 'compact' && _jsx(CookieCompact, {
      content: contentCompact,
      onConsentClick: function () {
        return handleConsentClick(true);
      },
      onLinkClick: function () {
        return toggleView('detail');
      }
    }), view === 'detail' && _jsx(CookieDetail, {
      content: contentDetail,
      cookiesConsent: cookiesConsent,
      onBackLinkClick: function () {
        return toggleView('compact');
      },
      onConsentClick: function () {
        return handleConsentClick(true);
      },
      onSaveClick: function () {
        return handleConsentClick();
      },
      onSwitchOption: handleSwitchOption
    })]
  });
};